import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center text-slate-500">
        <div className="text-sm tracking-widest uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="p-8 text-slate-700">
        <h2 className="text-2xl font-bold mb-2">Access Denied</h2>
        <p>Your role ({user.role}) does not have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
